export default __webpack_public_path__ + "static/media/pinterest.75ff25a1.png";